// src/blocks/move/moveRight.ts

import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';
import { BlocklyFields } from '../../BlocklyFields';
import i18next from 'i18next';

export function initJumpUpBlock() {

    Blockly.Blocks[BlocklyFields.JUMP_UP] = {
        init: function () {
            this.jsonInit({
                "type": BlocklyFields.JUMP_UP,
                "message0": '%1 ' + i18next.t('blockly.jump.up.message', 'Jump Up'),
                "args0": [
                    {
                        "type": "field_image",
                        "src": "/images/blocks/up.png", // Lien vers votre icône (chemin relatif ou absolu)
                        "width": 16,   // Largeur de l'image
                        "height": 16,  // Hauteur de l'image

                    }
                ],
                "previousStatement": null,
                "nextStatement": null,
                "colour": '#7A55CC',
                "tooltip": i18next.t('blockly.jump.up.tooltip', ''),
                "helpUrl": ""
            });

        },
    };
    javascriptGenerator.forBlock[BlocklyFields.JUMP_UP] = function (block, generator) {
        return 'await jumpCharacter(270);\n';
    }
}
